import React, { useEffect } from "react";
import { AutocompleteInput, ReferenceInput, required } from "react-admin";
import { useField } from "react-final-form";

interface ISubcontractorInput {
  record: any;
  parentSource: string;
}

const SubcontractorInput = ({ record, parentSource }: ISubcontractorInput) => {
  const {
    input: { onChange },
  } = useField(`${parentSource}.subcontractorId`);

  useEffect(() => {
    if (record) {
      if (record.subcontractorId) {
        onChange(record.subcontractorId);
      }
    }
  }, [record]);

  return (
    <ReferenceInput
      source={`${parentSource}.subcontractorId`}
      label="Subcontractor"
      reference="subcontractors"
      filter={{ Status: "active" }}
      filterToQuery={(searchText) => {
        if (searchText !== "") return { search: searchText };
      }}
      validate={required()}
      allowEmpty
    >
      <AutocompleteInput
        optionText={(choice: any) =>
          `${choice.name} (${choice.subcontractorIdentifier ?? "N/A"})`
        }
      />
    </ReferenceInput>
  );
};

export default SubcontractorInput;
